import { createActions } from 'redux-actions';

export const { jobAlertPreferencesUpdateRequest, jobAlertPreferencesUpdateSuccess } = createActions(
  'JOB_ALERT_PREFERENCES_UPDATE_REQUEST',
  'JOB_ALERT_PREFERENCES_UPDATE_SUCCESS',
);
